<template>
  <div class="table-responsive">
    <table class="table table-striped table-vcenter">
      <thead>
        <tr>
          <th width="10%">型号</th>
          <th class="text-center">序列号</th>
          <th class="text-center">零件号</th>
          <th class="text-center">所属项目</th>
          <th class="text-center">日报数量</th>
          <th class="text-center">创建时间</th>
          <th class="text-center">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="drill in list" :key="drill.id">
          <td>
            {{ drill.model_number || '无' }}
          </td>
          <td class="text-center">
            <DrillLink :no="drill.serial_number"></DrillLink>
          </td>
          <td class="text-center">
            {{ drill.component_number || '无' }}
          </td>
          <td class="text-center">{{ drill.project.name || '无' }}</td>
          <td class="text-center">
            <router-link
              :to="`/report/reports?drill_number=${drill.serial_number}`"
              class="text-primary"
              >{{ drill.reports.length }}</router-link
            >
          </td>
          <td class="text-center">{{ drill.option_time }}</td>
          <td class="text-center">
            <el-button
              v-code="22103"
              type="text"
              size="mini"
              @click="$router.push(`/report/drills/${drill.id}`)"
              >复合片记录</el-button
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
}
</script>